import mixpanel from 'mixpanel-browser';

import { InternalToolsTrackingEvents } from '@revelio/core';

export type DataInspectorAction =
  | 'enabled'
  | 'disabled'
  | 'opened_from_indicator'
  | 'opened_from_chart'
  | 'copied_request'
  | 'copied_response'
  | 'copied_request_id'
  | 'opened_playground';

/**
 * `data inspector used`. The drawer floats over every route, so the path is
 * stamped here rather than left to a page-level context it may not be under.
 */
export const trackDataInspectorUsed = (
  action: DataInspectorAction,
  props: {
    root_field?: string;
    chart_id?: string;
    snippet_format?: string;
  } = {}
) => {
  mixpanel.track(InternalToolsTrackingEvents.DATA_INSPECTOR_USED, {
    action,
    page_path: window.location.pathname,
    ...props,
  });
};
